<template>
  <nav class="specialLeftBox">
    <div class="specialNavBox">
      <div class="specialMainMenu">
        <ul>
          <li v-for="(menu) in topMenus" :key="menu.topMenuId" :class="{ active: $store.state.selectedMenuId === menu.topMenuId }">
            <router-link
              :to="newTapMenu(menu) ? '' : getRoute(menu)"
              :class="['specialMenubtn', { on: $store.state.selectedMenuId === menu.topMenuId }]"
              @click.prevent="goToMenu(menu)"
            >
            <img :src="getImageUrl(menu.menuSpecialImg)" alt="icon" class="menuIcon"/>
            <span>{{ menu.menuName }}</span>
            </router-link>
          </li>
          <router-link
            v-if="userModeAuthority === 'A' && userType === 'M'"
            to=''
            @click="changeMode()" class='specialMenubtn'
          >
            <img src="@/images/mode.png" alt="모드전환 아이콘" class="menuIcon" />
            <span>모드전환</span>
          </router-link>
        </ul>
      </div>
      <div class="specialSubMenu">
        <ul>
          <li class="specialSubMenuItem">
            <div class="specialListTitle" @click="toggleProject(0)">
              <span>프로젝트</span>
              <i :class="['bi', isProjectOpen[0] ? 'bi-chevron-up' : 'bi-chevron-down']"></i>
            </div>
            <ul v-show="isProjectOpen[0]" class="specialProjectList">
              <li v-for="project in leftProjectList" :key="project.projectId" :class="{ active: selectedProjectId === project.projectId }" @click="selectProject(project.projectId)">
                <i class="bi bi-app"></i>
                <span>{{ project.name }}</span>
              </li>
            </ul>
          </li>
          <!-- <li class="specialSubMenuItem">
            <div class="specialListTitle" @click="toggleProject(0)">
              <span>프로젝트</span>
              <i :class="['bi', isProjectOpen[0] ? 'bi-chevron-up' : 'bi-chevron-down']"></i>
            </div>
            <ul v-show="isProjectOpen[0]" class="specialProjectList">
              <li><i class="bi bi-app-indicator"></i><span>프로젝트명</span></li>
              <li class="active"><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
            </ul>
          </li>
          <li class="specialSubMenuItem">
            <div class="specialListTitle" @click="toggleProject(1)">
              <span>프로젝트</span>
              <i :class="['bi', isProjectOpen[1] ? 'bi-chevron-up' : 'bi-chevron-down']"></i>
            </div>
            <ul v-show="isProjectOpen[1]" class="specialProjectList">
              <li><i class="bi bi-app-indicator"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
              <li><i class="bi bi-app"></i><span>프로젝트명</span></li>
            </ul>
          </li> -->
        </ul>
      </div>

      <!-- 새 프로젝트 생성 버튼 -->
      <button class="specialAddProject" @click="showAddProjectPopup = true">
        <i class="bi bi-plus"></i>
        <span>새 프로젝트 생성</span>
      </button>
    </div>

    <div class="specialModalBg specialAddProjectModal" v-show="showAddProjectPopup">
      <div class="specialModalBox createTextFeedBox ">
        <div class="specialModalHeader">
          <div class="specialModalTitleBox">
            <div class="specialModalTitle">
              <h5>새 프로젝트 생성</h5>
            </div>
            <div class="specialModalHeaderBtnBox">
              <span class="closeBtn" @click="showAddProjectPopup = false"><i class="bi bi-x-lg"></i></span>
            </div>
          </div>
        </div>
        <div class="specialModalBody">
          <div class="specialNewProjectTitle">
            <div class="specialModalFeedTitleInputBox">
              <input type="text" class="specialModalFeedTitleInput" placeholder="제목을 작성하세요." v-model="projectName" ref="projectName">
            </div>
            <div class="specialModalFeedDesInputBox">
              <textarea v-model="projectDecription" class="specialModalFeedDesInput" placeholder="프로젝트 설명 입력 (옵션)"></textarea>
            </div>
          </div>
          <div class="specialNewProjectType">
            <div class="specialNewProjectTypeSetTitle">
              <i class="bi bi-grid"></i>
              <span>홈 탭 설정</span>
            </div>
            <div class="specialNewProjectTypeBtn">
              <button type="button" @click="selectHomeTabType('N')" :class="['optionBtn', selectedHomeTabType === 'N' ? 'active' : '']">피드</button>
              <button type="button" @click="selectHomeTabType('W')" :class="['optionBtn', selectedHomeTabType === 'W' ? 'active' : '']">업무</button>
              <button type="button" @click="selectHomeTabType('G')" :class="['optionBtn', selectedHomeTabType === 'G' ? 'active' : '']">간트차트</button>
              <button type="button" @click="selectHomeTabType('C')" :class="['optionBtn', selectedHomeTabType === 'C' ? 'active' : '']">캘린더</button>
              <button type="button" @click="selectHomeTabType('F')" :class="['optionBtn', selectedHomeTabType === 'F' ? 'active' : '']">파일</button>
            </div>
          </div>
          <div class="specialNewProjectSet">
            <div class="specialSetItem">
              <div class="specialNewProjectTypeSetTitle">
                <i class="bi bi-lock"></i>
                <span>관리자 승인 후 참여가능</span>
              </div>
              <div class="specialToggleBtn">
                <label class="toggleSwitch">
                  <input type="checkbox" class="toggleInput" id="toggle" :checked="selectedAdminApprovalYn === 'Y'" @change="selectAdminApprovalYn(selectedAdminApprovalYn ? 'Y' : 'N')"/>                  
                  <label class="toggleLabel" for="toggle"></label>
                </label>
              </div>
            </div>
            <div class="specialSetItem">
              <div class="specialNewProjectTypeSetTitle">
                <i class="bi bi-sliders"></i>
                <span>권한 설정</span>
              </div>
              <div class="specialSetDetailBtn">
                <!-- .specialSetDetail.active 시 text 취소로 변경 -->
                <div class="underlineBtn" @click="showProjectPermission = !showProjectPermission">
                  {{ showProjectPermission ? '취소' : '선택' }}
                </div>
              </div>
            </div>

            <!-- .specialSetDetailBtn > .underlineBtn 클릭시 .active -->
            <div :class="['specialSetDetail', showProjectPermission ? 'active' : '']">
              <div class="specialSetDetailItem">
                <b>게시글</b>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">작성 권한</div>
                  <select class="dropdown" v-model="selectedCreatePost">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_ONLY">프로젝트 관리자만</option>
                  </select>
                </div>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">수정 권한</div>
                  <select class="dropdown" v-model="selectedEditPost">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_AND_AUTHOR">프로젝트 관리자 + 작성자만</option>
                    <option value="AUTHOR_ONLY">작성자만</option>
                  </select>
                </div>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">조회 권한</div>
                  <select class="dropdown" v-model="selectedViewPost">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_AND_AUTHOR">프로젝트 관리자 + 작성자만</option>
                  </select>
                </div>
                <div class="specialNoticeItem">
                  ＊ 게시글 조회 권한은 프로젝트 생성 후에는 변경할 수 없습니다.
                </div>
              </div>
              <div class="specialSetDetailItem">
                <b>댓글</b>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">작성 권한</div>
                  <select class="dropdown" v-model="selectedCreateComment">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_ONLY">프로젝트 관리자만</option>
                  </select>
                </div>
              </div>
              <div class="specialSetDetailItem">
                <b>파일</b>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">조회 권한</div>
                  <select class="dropdown" v-model="selectedViewFile">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_AND_AUTHOR">프로젝트 관리자 + 작성자만</option>
                  </select>
                </div>
                <div class="specialIndexDropdownItem">
                  <div class="specialDropdownIndex">다운로드 권한</div>
                  <select class="dropdown" v-model="selectedDownloadFile">
                    <option value="ALL" selected>전체</option>
                    <option value="ADMIN_AND_AUTHOR">프로젝트 관리자 + 작성자만</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="specialModalFooter"> 
          <div class="specialModalFooterBtnBox">
            <button class="blueBtn" @click="addProject">등록</button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import apiClient from "@/apiClient";
import { useToast } from "vue-toastification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {    
      prevLeftMenus: [],
      isProjectOpen: [false, false],      
      showAddProjectPopup: false,
      showProjectPermission: false,     // 프로젝트 등록 팝업의 권한 설정 부분 View 여부
      selectedHomeTabType: 'N',         // 홈 탭 설정(default : 'N' => 피드)
      selectedAdminApprovalYn: false,   // 관리자 승인 후 참여가능 여부(default : false => 승인필요X)
      selectedCreatePost: 'ALL',        // 게시글 작성 권한(default : 'ALL' => 전체)
      selectedEditPost: 'ALL',          // 게시글 수정 권한(default : 'ALL' => 전체)
      selectedViewPost: 'ALL',          // 게시글 조회 권한(default : 'ALL' => 전체)
      selectedCreateComment: 'ALL',     // 댓글 작성 권한(default : 'ALL' => 전체)
      selectedViewFile: 'ALL',          // 파일 조회 권한(default : 'ALL' => 전체)
      selectedDownloadFile: 'ALL',      // 파일 다운로드드 권한(default : 'ALL' => 전체)
      alertMsg: {
        projectName: '프로젝트명을 입력해주세요.',
        successProjectAdd: '프로젝트 성공적으로 등록되었습니다.', 
        failProjectAdd: '프로젝트 등록 중 오류가 발생했습니다.'
      },
      leftProjectList: [],
      selectedProjectId: null,
    };
  },
  computed: {
    topMenus() {
      return Array.isArray(this.$store.state.topMenus) ? this.$store.state.topMenus : [];
    },
    leftMenus() {
      return this.$store.getters.getFilteredLeftMenus;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userModeAuthority() {
      return this.$store.getters.getUserModeAuthority;
    },
  },
  methods: {
    toggleProject(index) {
      this.isProjectOpen[index] = !this.isProjectOpen[index];
    },
    getRoute(menu) {
      if (typeof menu === 'string') return menu;
      if (menu.menuLink) return '/' + menu.menuLink.replace(/^\/+/, '');
      return '/';
    },
    getImageUrl(imgFileName) {
      try {
        return require(`@/images/${imgFileName}`)
      } catch (e) {
        console.error('이미지 로드 실패', imgFileName)
        return ''
      }
    },
    newTapMenu(menu) {
      return menu.menuName === 'CS' || menu.menuName === '방문객예약';
    },
    goToMenu(menu) {    
      if (this.newTapMenu(menu)) {
        const url = menu.menuDomain + menu.menuLink + localStorage.getItem("encryptUserid");
        window.open(url, '_blank');
        return;
      }
      if (menu.menuLink === '') {
        alert('준비중입니다.');
        this.$store.commit('setSelectedMenu', '공지사항');
        this.$store.commit('setSelectedMenuId', this.findTopMenuId(this.topMenus, 'M', '공지사항'));

        if (this.$store.state.menuMode === 'M')
          this.$router.push({ path: "/mizenotices/list" });
        
        return;
      }
      
      this.$store.commit('setSelectedMenu', menu.menuName);
      this.$store.commit('setSelectedMenuId', menu.topMenuId);
      
      if (menu.menuLink === this.$route.path) {
        const currentPath = this.$route.path;
        this.$store.commit('setRefreshFlag', true);

        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.replace(currentPath);
        });
      }
      else {
        this.$store.commit('setRefreshFlag', false);
        return this.$route.path
      }
    },
    findTopMenuId(menuData, menuMode, menuName) {
      const matchedMenu = menuData.find(menu => {
        return menu.menuName === menuName && menu.menuMode === menuMode;
      });

      if (matchedMenu) {
        return matchedMenu.topMenuId;
      }
    },
    setSelectedTopMenuByRoute() {
      const currentPath = this.$route.path;
      const matchedMenu = this.topMenus.find(menu => {
        return menu.menuLink && menu.menuLink === currentPath;
      });
      
      if (matchedMenu) {        
        this.$store.commit('setSelectedMenuId', matchedMenu.topMenuId);
      }
    },
    async changeMode() {
      this.prevLeftMenus = [...this.$store.state.leftMenus];
      let menuMode = '';
      menuMode = this.$store.state.menuMode === 'M' ? 'C' : 'M';
      this.$store.commit('setMenuMode', menuMode);      
      this.$store.commit('setTopMenus', []); 
      this.$store.commit('setLeftMenus', []);
      await this.getTopMenu(menuMode);
    },
    async getTopMenu(menuMode = this.$store.state.menuMode) {
      if (this.$store.state.topMenus.length > 0) return;
      
      try {
        const user = {
          LoginUserId: localStorage.getItem("userid"),
          UserType: localStorage.getItem("usertype"),
          MenuMode: menuMode
        };

        const response = await apiClient.post("/api/Menu/top-menu-list", user);

        if (response.status === 200) {               
          this.$store.commit("setTopMenus", JSON.parse(response.data).data);
          this.setSelectedTopMenuByRoute();
          this.getLeftMenu();
        }
      } catch (error) {
        console.error("Error fetching top menu data:", error);
      }
    },
    async getLeftMenu() {   
      if (this.$store.state.leftMenus.length > 0) return;
 
      try {
        const user = {
          LoginUserId: localStorage.getItem("userid"),
          UserType: localStorage.getItem("usertype"),
          TopMenuId: this.$store.state.selectedMenuId,
          MenuMode: this.$store.state.menuMode
        };

        const response = await apiClient.post("/api/Menu/left-menu-list", user);

        if (response.status === 200) {            
          const originData =  JSON.parse(response.data).data;
          const addMyinfoData = {
            id: 0,
            topMenuId: 0,
            leftMenuId: 0,
            menuName: "내 정보 수정",
            menuDomain: "https://mizecloud-partners.co.kr",
            menuLink: "/myinfo/view"
          }
          const addNotiData = {
            id: 0,
            topMenuId: -1,
            leftMenuId: 0,
            menuName: "알림목록",
            menuDomain: "https://mizecloud-partners.co.kr",
            menuLink: "/alarmsnotices/list"
          }
          
          let mergedData = [...originData, addMyinfoData, addNotiData, ...this.prevLeftMenus];
          const filteredData = mergedData.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.menuLink === item.menuLink)
          );

          mergedData = filteredData;
          this.$store.commit("setLeftMenus", mergedData);   
        }
      } catch (error) {
        console.error("Error fetching left menu data:", error);
      }
    },
    async getLeftProjectList() {
      try {
        const response = await apiClient.post(`/api/Project/left-project-list`, {          
        });

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.leftProjectList = data.data;
        }
      } catch (error) {
        console.error("Error fetching left project list data:", error);
      }
    },
    async addProject() {
      if (!this.projectName || this.projectName.trim() === "") {
        this.toast.success(this.alertMsg['projectName'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.projectName.focus();
        return; 
      }

      try {
          const response = await apiClient.post(`/api/Project/project-add`, {
            LoginUserId: localStorage.getItem("userid"),
            Name: this.projectName,
            Description: this.projectDecription,
            HomeTabType: this.selectedHomeTabType,
            AdminApprovalYn: this.selectedAdminApprovalYn,
            CreatePost: this.selectedCreatePost,
            EditPost: this.selectedEditPost,
            ViewPost: this.selectedViewPost,
            CreateComment: this.selectedCreateComment,
            ViewFile: this.selectedViewFile,
            DownloadFile: this.selectedDownloadFile
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successProjectAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddProjectPopup = false;
            this.initVaule();
          }
      } catch (error) {
        console.error("Error adding project data:", error);
        this.toast.error(this.alertMsg['failProjectAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    initVaule() {
      this.projectName = this.projectDecription = '';
      this.selectedHomeTabType = 'N';
      this.selectedAdminApprovalYn = false;
      this.selectedCreatePost = this.selectedEditPost = this.selectedViewPost = this.selectedCreateComment = this.selectedViewFile = this.selectedDownloadFile = 'ALL';
    },
    selectHomeTabType(type) {
      this.selectedHomeTabType = type;
    },
    selectAdminApprovalYn(type) {
      this.selectedAdminApprovalYn = type;
    },
    selectProject(projectId) {
      this.selectedProjectId = projectId;
    },
  },
  mounted() {
    this.getLeftProjectList();
  },
};
</script>
